import { IAdolescentHouseholdMemberDto, IStatus } from '@/shared/interfaces';
import { fetchIStatus } from '@/shared/fetchIStatus';

export const deleteAdolescentHouseholdMember = async (
    memberDto: IAdolescentHouseholdMemberDto,
): Promise<IStatus<string>> => {
    return await fetchIStatus(
        '/api/patients/adolescent-household-member/delete',
        'post',
        { Cpr: memberDto.Cpr },
    );
};
